import { makeStyles } from '@material-ui/core/styles';

export const createStyles = makeStyles((theme) => ({
  '@global': {
    '.ng-ui-widgets': {
      '&$titleBar': {
        background: `${theme.palette.base.white}`,
        color: `${theme.palette.base.black}`,
        borderBottom: `solid 1px ${theme.palette.shadows.shadowBlack}`,
        '& section': {
          '& *': {
            color: `${theme.palette.base.black} !important`,
          },
        },
      },
    },
  },
  appBar: {
    position: 'relative',
  },
  dialogContent: {
    paddingTop: 30,
    background: `${theme.palette.base.offWhite}`,
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  titleBar: {
    background: `${theme.palette.base.white} !important`,
    color: `${theme.palette.base.black}`,
    borderBottom: `solid 1px ${theme.palette.shadows.shadowBlack}`,
    '& section': {
      '& *': {
        color: `var(--prs-c-gray-950) !important`,
      },
    },
  },
}));
